import {
  Form,
  TextFields,
  SelectField,
  TextArea,
  RadioField,
  CheckField,
  DateField,
  TimeField,
  SubmitButton,
} from "./FormElements";
import { Button, Row, Col } from 'reactstrap';

import React, { useEffect, useState } from "react";
import { formData } from "./formData";
import { createYupSchema } from "./yupSchemaCreator";
import * as yup from "yup";

function NewLicense() {
  
  
  const renderFormElements = (Receiveprops) => {
    
    const props = {
      name: Receiveprops.id,
      label: Receiveprops?.label,
      options: Receiveprops.options,
      placeholder: Receiveprops.placeholder,
      type: Receiveprops.type,
    };
    if (props.type === "text" || props.type === "email") {
      return <TextFields {...props} />;
    }

    if (props.type === "textarea") {
      return <TextArea {...props} />;
    }

    if (props.type === "radio") {
      return <RadioField {...props} />;
    }

    if (props.type === "select") {
      return <SelectField {...props} />;
    }

    if (props.type === "checkbox") {
      return <CheckField {...props} />;
    }

    if (props.type === "date") {
      return <DateField {...props} />;
    }

    if (props.type === "time") {
      return <TimeField {...props} />;
    }

    if (props.type === "button") {
      return <SubmitButton {...props} />;
    }
    
  };

  const initialValues = {};
  const [validationSchema, setValidationSchema] = useState("");

  useEffect(() => {
    formData.forEach((item) => {
      initialValues[item.id] = item.value || "";
    });
    const yepSchema = formData.reduce(createYupSchema, {});
    setValidationSchema(yup.object().shape(yepSchema));
  }, []);

  return (
    <div className="form card card-body">
      <h4 className="mb-4">Form here</h4>
      <Form
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
        }}
      >
        <Row>
        {formData.map((data, ind) => (

<Col md="4">
          <div className="form-group" key={ind}>{renderFormElements(data)}</div>
          </Col>
     
        ))}
             </Row>
        <Button color="primary" className="mt-4 d-block m-auto" type="submit">Submit</Button>
      </Form>
    </div>
  );
}

export default NewLicense;
